var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF5349"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.2857,
    height: 18.2857,
    transform: "translate(6.85718 6.85693)",
    fill: "#FF5349"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6105 23.3782V13.3278H8.2729V23.3782H11.6109H11.6105ZM9.94242 11.9558C11.1061 11.9558 11.8305 11.1841 11.8305 10.2196C11.8088 9.23313 11.1061 8.48291 9.96455 8.48291C8.82224 8.48291 8.07617 9.23313 8.07617 10.2195C8.07617 11.184 8.80037 11.9557 9.92055 11.9557H9.94216L9.94242 11.9558ZM13.458 23.3782H16.7954V17.7662C16.7954 17.4662 16.8171 17.1655 16.9053 16.9512C17.1465 16.3508 17.6956 15.7293 18.6179 15.7293C19.8253 15.7293 20.3086 16.6509 20.3086 18.0021V23.3782H23.6459V17.6156C23.6459 14.5287 21.9995 13.0922 19.8037 13.0922C18.0034 13.0922 17.2127 14.0993 16.7734 14.7852H16.7956V13.3281H13.4581C13.5017 14.271 13.4579 23.3786 13.4579 23.3786L13.458 23.3782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.c0165f91ce503922b78e8d14f47b12df.svg";
export { ForwardRef as ReactComponent };